import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowConsumerOfPatientSchema } from '../consumer.js';
import { FlowBlockType } from '../type.js';
export const FlowExportTextToBucketBlockConfigSchema = z.object({
    patient: FlowConsumerOfPatientSchema({ isRequired: false }),
    source: z.string().min(1, { message: 'Data to export is required' }),
});
export const FlowExportTextToBucketBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.ExportTextToBucket),
    config: FlowExportTextToBucketBlockConfigSchema,
});
//# sourceMappingURL=config.js.map